import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export const SessionCardPlaceholder = (props: IContentLoaderProps) => {
  return (
    <ContentLoader
      style={{ maxHeight: '90px' }}
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      preserveAspectRatio="none"
      {...props}
    >
      <rect x="12" y="12" rx="8" ry="8" width="48" height="48" />
      <rect x="72" y="12" rx="8" ry="8" width="40%" height="14" />
      <rect x="72" y="36" rx="8" ry="8" width="70%" height="14" />
    </ContentLoader>
  );
};
